import { Button } from "@workspace/web-ui/components/button";
import { NotebookIcon } from "lucide-react";
import useEncounterStore from "../../../store/encounter-store";
import useAddNoteStore from "../../../store/add-note-store";

const NoNotesCard = ({ encounterId, patientId }: { encounterId: string, patientId: string }) => {
    const { openNoteModal } = useAddNoteStore()
    const { setEncounterId } = useEncounterStore()

    const handleAddNotes = () => {
        openNoteModal(undefined, patientId)
        setEncounterId(encounterId)
    }
    return (
        <div className="w-full flex flex-col items-center px-4 py-6 justify-center gap-4 self-center rounded-lg border border-[#E6E6E6] bg-white">
            <NotebookIcon className="size-16 text-[#FFAB1F]" />
            <h2 className="text-lg font-medium text-[#2D2F35]">You haven&lsquo;t logged any notes yet</h2>

            <Button onClick={handleAddNotes} className="button-primary !bg-[#427DDD] !text-white !shadow-none !border-none">Add Notes</Button>
        </div>
    )
}

export default NoNotesCard;